const alarmMonitorEn = {
  alarmMonLang: {
    告警总览: 'Alarm Overview',
    待运维处理电站: 'Waiting O&M processing station',
    个: '',
    告警中电站: 'Power station under alarm',
    待运维处理告警: 'Waiting O&M processing alarm',
    发生中告警: 'During alarm',
    告警电站: 'Alarm power station',
    告警列表: 'Alarm List',
    站点名称: 'Site name',
    电站筛选: 'Power plant screening',
    全部电站: 'All power stations',
    无需关注电站: 'No need to pay attention to the power station',
    待运维电站: 'Waiting O&M station',
    查询: 'Query',
    重置: 'Reset',
    电站名称: 'Name of power station',
    告警总数: 'Total number of alarms',
    待运维告警: 'Waiting O&M alarm',
    无需关注告警: 'No need to pay attention to alarms',
    操作: 'Operation',
    告警详情: 'Alarm details',
    暂无数据: 'No data available',
    电站告警详情: 'Power plant alarm details',
    全部: 'All',
    设备类型: 'Device type',
    全选: 'Select All',
    告警等级: 'Warning level',
    告警类型: 'Alarm type',
    处理建议: 'Treatment suggestion',
    时间范围: 'Time frame',
    开始时间: 'Start time',
    结束时间: 'Finish time ',
    站点系统: 'Site System',
    设备名称: 'Device name',
    等级: 'Grade',
    告警标题: 'Alarm title',
    客户告警: 'Customer alarm',
    告警开始时间: 'Alarm start time',
    详情: 'Details',
    电站系统: 'Power plant system',
    告警结束时间: 'Alarm end time',
    返回: 'Return',
    设备: 'Device',
    业务: 'Business',
    通讯: 'Communication',
    未分级: 'Ungraded',
    一般: 'Normal',
    重要: 'Important',
    严重: 'Serious',
    运维处理: 'O&M handling',
    故障状态: 'Fault status',
    运维告警详情: 'O&M alarm details',
    发生中: 'In progress',
    已结束: 'Ended'
  }
}
export default alarmMonitorEn
